// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage, intlShape } from 'react-intl';
import Slider from 'react-slick/lib';
import { Mobile, Desktop, Tablet, Default } from '../../utils/responsive';
import Arrow from '../Arrow/Arrow';
import Testimonial from './Testimonial/Testimonial';
import VideoModal from '../../modules/home/components/Discover/VideoModal';
import { travelersTestimonials } from '../../modules/testimonials/components/TravelerTestimonials';

import style from './CarouselTestimonials.scss';
import icons from '../../assets/styles/icons.scss';
import discoverStyle from '../../modules/home/components/Discover/Discover.scss';

// purchasers
import jano from '../../assets/img/home/testimonials/Jano.png';
import miguel from '../../assets/img/home/testimonials/Miguel.png';
import oscar from '../../assets/img/home/testimonials/Oscar.png';
import adrian from '../../assets/img/home/testimonials/Adrian.png';
import saul from '../../assets/img/home/testimonials/Saul.png';
import manuel from '../../assets/img/home/testimonials/Manuel.png';
import juan from '../../assets/img/home/testimonials/Juan.png';
import sebastian from '../../assets/img/home/testimonials/Sebastian.png';

import lina from '../../assets/img/testimonials/lina.png';
import jose from '../../assets/img/testimonials/jose.png';
import ronaldo from '../../assets/img/testimonials/ronaldo.png';

import type { Element, ComponentType } from 'react';
import type { Country } from '../../entities';
import type { TestimonialItem } from './Testimonial/Testimonial';

type Props = {
  +userType: 'purchaser' | 'traveler';
  +country: Country;
};

type State = {
  videoUrl: string;
  modalVisible: boolean;
  lightningRightArrow: boolean;
  lightningLeftArrow: boolean;
};

const purchasersTestimonialsPE: TestimonialItem[] = [
  {
    image: jano,
    name: 'Jano',
    textIntl: 'home.testimonialsBlock.testimonial1.PE.text',
  },
  {
    image: miguel,
    name: 'Miguel',
    textIntl: 'home.testimonialsBlock.testimonial2.PE.text',
  },
  {
    image: oscar,
    name: 'Oscar',
    textIntl: 'home.testimonialsBlock.testimonial3.PE.text',
  },
  {
    image: adrian,
    name: 'Adrian',
    textIntl: 'home.testimonialsBlock.testimonial4.PE.text',
  },
  {
    image: saul,
    name: 'Saul',
    textIntl: 'home.testimonialsBlock.testimonial5.PE.text',
  },
  {
    image: manuel,
    name: 'Manuel',
    textIntl: 'home.testimonialsBlock.testimonial6.PE.text',
  },
  {
    image: juan,
    name: 'Juan',
    textIntl: 'home.testimonialsBlock.testimonial7.PE.text',
  },
  {
    image: sebastian,
    name: 'Sebastian',
    textIntl: 'home.testimonialsBlock.testimonial8.PE.text',
  },
];

const purchasersTestimonialsCO: TestimonialItem[] = [
  {
    image: ronaldo,
    name: 'Ronaldo Muñetones',
    textIntl: 'home.testimonialsBlock.testimonial.CO.first.text',
  },
  {
    image: jose,
    name: 'Jose Rentería',
    textIntl: 'home.testimonialsBlock.testimonial.CO.second.text',
  },
  {
    image: lina,
    name: 'Lina Torres',
    textIntl: 'home.testimonialsBlock.testimonial.CO.third.text',
  },
  /*{
    image: oscar,
    name: 'Oscar Ospina',
    location: 'Cali, Colombia',
    textIntl: 'home.testimonialsBlock.testimonial.CO.fourth.text',
    video: 'https://www.youtube.com/embed/yJMPD3PAEYs?rel=0&amp;controls=0&amp;showinfo=0&amp;autoplay=1',
  },
  {
    image: alejandrii,
    name: 'Alejandro Valencia',
    location: 'Manizales, Colombia',
    textIntl: 'home.testimonialsBlock.testimonial.CO.fifth.text',
    video: 'https://www.youtube.com/embed/poknaJrQiR0?rel=0&amp;controls=0&amp;showinfo=0&amp;autoplay=1',
  },*/
];

const testimonial: { [string]: { [key: Country]: TestimonialItem[] } } = {
  traveler: {
    PE: travelersTestimonials,
    CO: travelersTestimonials,
    US: travelersTestimonials,
  },
  purchaser: {
    PE: purchasersTestimonialsPE,
    CO: purchasersTestimonialsCO,
    US: purchasersTestimonialsPE,
  },
};

export default class CarouselTestimonials extends Component<Props, State> {
  state = {
    videoUrl: '',
    modalVisible: false,
    lightningRightArrow: false,
    lightningLeftArrow: true,
  };

  handleOpenModal(videoUrl: string) {
    this.setState({ modalVisible: true, videoUrl });
  }

  handleCloseModal() {
    this.setState({ modalVisible: false });
  }

  handleArrowStyle(current: number, lastIndex: number) {
    const lightningLeftArrow = current === 0;
    const lightningRightArrow = current === lastIndex;
    this.setState({ lightningLeftArrow, lightningRightArrow });
  }

  buildTestimonialsBox(userType: 'purchaser' | 'traveler', country: Country): Element<any>[] {
    const items = testimonial[userType][country] ? testimonial[userType][country] : testimonial[userType]['PE'];
    return items.map((item: TestimonialItem, n: number) =>
      <article key={n}
               className={style.testimonialWrap}>
        <section className={classNames(style.testimonial, style[userType])}>
          <section className={style.imageWrap}>
            {/*<button className={classNames(discoverStyle.discover, style.discover, discoverStyle.white)}
                    onClick={this.handleOpenModal.bind(this, item.video)}
                    type="button">
              <div className={discoverStyle.circleAndPlay}>
                <i className={classNames(icons.symbolPlay, style[userType === 'purchaser' ? 'lightBlue' : 'orange'])}/>
              </div>
            </button>*/}
            <img src={item.image} alt={item.name}/>
          </section>
          <section className={style.content}>
            <p className={style.name}>{item.name}</p>
            {userType === 'traveler' && item.flight && (
              <section className={style.flight}>
                <p>{item.flight.departure}</p>
                <div>
                  <span>&#8226;</span>
                  <i className={icons.iconAirplaneMedium}/>
                  <span>&#8226;</span>
                </div>
                <p>{item.flight.arrival}</p>
              </section>)}
            <FormattedMessage id={item.textIntl}>{
              txt => <p className={style.text}>{txt}</p>
            }</FormattedMessage>
          </section>
        </section>
      </article>);
  }

  render() {
    const { lightningRightArrow, lightningLeftArrow, modalVisible, videoUrl } = this.state;
    const { userType, country } = this.props;
    const testimonials = this.buildTestimonialsBox(userType, country);
    const options = {
      infinite: true,
      slidesToScroll: 1,
      dots: false,
      nextArrow: <Arrow icon={icons.iconChevronRightMedium}
                        positionClass={style.arrowRight}
                        visible={lightningRightArrow}/>,
      prevArrow: <Arrow icon={icons.iconChevronLeftMedium}
                        positionClass={style.arrowLeft}
                        visible={lightningLeftArrow}/>,
      dotsClass: classNames('slick-dots',
        { [style.dotsPurchaser]: userType === 'purchaser' },
        { [style.dotsTraveler]: userType === 'traveler' }),
    };

    const mobileSettings = {
      ...options,
      arrows: true,
      draggable: true,
      slidesToShow: 1,
      afterChange: (current) => this.handleArrowStyle(current, 3),
    };
    const defaultSettings = {
      ...options,
      arrows: testimonials.length > 3,
      slidesToShow: 3,
      draggable: true,
      afterChange: (current) => this.handleArrowStyle(current, testimonials.length - 3),
    };

    return (
      <section className={style.carousel}>
        <Mobile>
          <Slider {...mobileSettings}>
            {testimonials}
          </Slider>
        </Mobile>
        <Default>
          <Slider {...defaultSettings}>
            {testimonials}
          </Slider>
        </Default>
        {/*<VideoModal handleClose={this.handleCloseModal.bind(this)}
                    modalVisible={modalVisible}
                    url={videoUrl}/>*/}
      </section>)
  }
}

CarouselTestimonials.propTypes = {
  userType: PropTypes.string.isRequired,
};

CarouselTestimonials.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/elements/CarouselTestimonials/CarouselTestimonials.jsx